/** Smallest visible time span when zoomed in. */
export const minZoomWidthMs = 1000;

/** Pixels per wheel line (deltaMode 1): Firefox sends ±3 lines for a notch Chrome reports as ±100px. */
export const wheelLineHeightPx = 33;

/** Pixels per wheel page (deltaMode 2). */
export const wheelPageHeightPx = 800;

/** Zoom per wheel delta pixel; a mouse wheel notch is typically 100. */
export const mouseWheelZoomSpeed = 0.002;

/** Trackpad pinch reports small deltas, so it needs a higher gain than a mouse wheel. */
export const pinchZoomSpeed = 0.01;
